module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-bg"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('blue-btn', {
    attrs: {
      "info": "返回",
      "handle-click": _vm.cancel
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "desc-block img-block"
  }, [_c('p', [_vm._v("班级出勤人数图片")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "overflow"
  }, [_c('card-view', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.url,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "on-change": _vm.handleChange,
      "accept": '.jpg,.jpeg,.png,.bmp',
      "headers": _vm.headers,
      "multiple": "",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper2"
  }, [_c('blue-btn', {
    attrs: {
      "info": "提交",
      "handle-click": _vm.submits
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3c19870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UpImage.vue
// module id = 798
// module chunks = 1